<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <student-header [pageTitle]="'Meal Service'" [showYearSelector]="true" class="flex-header print-ignore-flex-basis" #studentHeader
                style="flex-basis: auto">
                <div *ngIf="selectionIndex == 0" style="display:flex; justify-content:flex-end;">
                    <table>
                        <tr *ngIf="totalRollOver!=0">
                            <td style="padding-left:5px;padding-right:30px;" translate>Rollover Balance</td>
                            <td style="text-align:right;">&nbsp;{{totalRollOver | currency}}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style="padding-left:5px;padding-right:30px;" translate>Deposits</td>
                            <td style="text-align:right;">&nbsp;{{totalDeposit | currency}}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style="padding-left:5px;padding-right:30px;" translate>Charges</td>
                            <td style="text-align:right;">&nbsp;<span
                                    style="text-decoration:underline;">{{totalPurchases | currency}}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr style="font-weight:bold;" [ngStyle]="{'background-color':totalBalance <= 0 ? '#ffff99' : ''}">
                            <td style="padding-left:5px;padding-right:30px;"
                                [ngStyle]="{'background-color': totalBalance <= 0 ? '#ffff99': ''}" translate>Balance</td>
                            <td style="text-align:right;"
                                [ngStyle]="{'background-color': totalBalance <= 0 ? '#ffff99': ''}">
                                &nbsp;{{(totalBalance < 0 ? totalBalance*-1 : totalBalance) | currency }}
                            </td>
                            <td *ngIf="totalBalance < 0" style="background-color:#ffff99">&nbsp;<span
                                    translate>Overdrawn</span></td>
                        </tr>
                    </table>
                </div>
            </student-header>
            <div *ngIf="lunchPin" align="right">
                <span translate>Meal PIN</span> &nbsp;
                <span *ngIf="showPassword==false">
                    <span *ngFor="let item of lunchPin | lunchPinFilter lunchPin">
                        *
                    </span>
                </span>
                <span *ngIf="showPassword==true">{{lunchPin}}</span>&nbsp;
                <tyl-button *ngIf="!showPassword" image="visibility.png" [iconWidth]="20" (click)="viewPassword(true)"></tyl-button>
                <tyl-button *ngIf="showPassword" image="visibilityOff.png" [iconWidth]="20" (click)="viewPassword(false)"></tyl-button>
            </div>
            <tabs *ngIf="tabNames && tabNames.length > 1" [startingIndex]="selectionIndex" [tabNames]="tabNames"
                style="margin-bottom: 10px" (selectionsChangeIndex)="selectionChange($event)">
            </tabs>

            <div *ngIf="selectionIndex == 1"
                style="display: flex; width: 100%; background: white; z-index: 999; align-items: center; justify-content: space-between; padding-right: 20px; padding-left: 20px">
                <div style="display: flex; flex-direction: row; flex: 1;">
                    <div id="dayControl" style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start">
                        <button style="width: 100px" class="mat-nav-button" mat-stroked-button mwlCalendarPreviousView
                            (click)="changeDate('prev')" [disabled]="DisabledPrvBtn" translate>
                            <span translate>Previous</span>
                        </button>
                        <button style="width: 110px" class="mat-nav-button" mat-stroked-button mwlCalendarToday
                            (click)="changeDate('today')">
                            <span translate>This Month</span>
                        </button>
                        <button style="width: 100px" class="mat-nav-button" mat-stroked-button mwlCalendarNextView
                            (click)="changeDate('next')" [disabled]="DisabledNxtBtn" translate>
                            <span translate>Next</span>
                        </button>
                    </div>
                    <div id="dateDisplay" style="display: flex; flex-direction: row; flex: 1; justify-content: center">
                        <h3>{{selectedMonth | translate}}&nbsp; {{selectedYear}}</h3>
                    </div>
                    <div id="viewControl" style="display: flex; flex-direction: row; flex: 1; justify-content: flex-end">
                    </div>
                </div>
            </div>
            <div class="flex-content" style="height: 100%">
                <div *ngIf="selectionIndex == 0 && mealService != undefined && mealService.length > 0">
                    <charges-and-deposits #byViewCharges [mealService]="mealService" [lunchMealChoice]="lunchMealChoice"></charges-and-deposits>
                </div>
                <div *ngIf="selectionIndex == 1 && mealService != undefined && mealService.length > 0">
                    <monthly-lunch-menu [lunchMealChoice]="lunchMealChoice" [currentDate]="currentDate" #byViewMonthly>
                    </monthly-lunch-menu>
                </div>
            </div>            
            </tyl-kendo-pdf-export>
            <div #footer class="flex-footer">
                <div class="flex-footer-left">
                    <div *ngIf="selectionIndex == 0">
                        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
                        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)">
                        </tyl-button>
                        <tyl-button id="mealSerivceFilter" image="filter.png" label="Filter"
                            (clickEvent)="showFilterClick()" *ngIf="!filtered"></tyl-button>
                        <tyl-button id="mealServiceFilterYellow" image="filter yellow.png" label="Filter"
                            (clickEvent)="showFilterClick()" *ngIf="filtered"></tyl-button>
                    </div>
                </div>
                <div class="flex-footer-middle">
                    <div *ngIf="selectionIndex == 0">
                        <filter-notification style="align-self: center" [filtered]="isFiltered() || filtered"
                            (clearFilter)="clearFilter();">
                        </filter-notification>
                    </div>
                    <div *ngIf="selectionIndex == 1">
                        <filter-notification style="align-self: center" [filtered]="isFiltered()"
                            (clearFilter)="clearFilter();">
                        </filter-notification>
                    </div>
                </div>
                <div class="flex-footer-right">
                    <div
                        *ngIf="student360Year.EnableOnlinePayment==true && parentPortalShowOnlinePayment==true && userType==2 && onlinePaymentConfiguration.StudentMealOnlinePayment==true">
                        <tyl-button image="OnlinePayment.png" *ngIf="selectionIndex == 0" label="Online Payment"
                            (clickEvent)="onlinePaymentClick()"></tyl-button>
                    </div>
                </div>
            </div>
        </div>
    <app-meal-service-filter *ngIf="showFilter" [showFilter]="showFilterEvent" [clearFilter]="clearFilterEvent"
        (closeFilterEvent)="showFilterClick()" [filterData]="mealServiceFilter" (filterChange)="filterChange()"
        class="filter-body"></app-meal-service-filter>

</div>
